exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contact[data-v-4e5abd8b]{border-top:0}", ""]);

// exports
